var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { eventDetailSubject, marketMapping, sportsbookFilter, sportsbookList, sportsSummery } from "../../store/sportsbook.store";
import { useForceUpdate } from "../../lib/misc.functions";
import _ from "lodash";
import { generateCompetitionGroupList, generatePreCompetitionsGroupList, mobileHighLightedMarket, myHighLightedMarketGroups, myHighLightedMarketGroups2, } from "../../services/sportsbook.services";
import { eventDetailVisiblity } from "./eventdetail";
import { getEvent } from "../../services/societyWon.services";
import { Eventlist } from "./widgets/eventlist";
import { highLightedMarketCategories } from "../../definitions/constants/market-categories.constant";
import { societywonEventIdMapping } from "../societywon/subpages/posts";
import { eventEndedStatuses } from "../../definitions/constants/event-result-type";
import { getFromLanguageFile, isMobileView } from "../../app";
import { useNavigate } from "react-router";
import { betSlipVisibleSubject } from "../../store/betslip.store";
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import { modalServiceSubject } from "../../components/modal/modal";
import { Storage } from "../../lib/localstorege.service";
import { MobileEvent } from "./components/event";
import SideSquare from "../../assets/img/side-square.svg";
import SportBookSideMenu from "../../shared/sidemenu/sportbook-sidemenu";
import SportsHeader from "../../shared/sportsHeader/sports-header";
import MobileSportsFilter from "../../shared/sportsHeader/mobile-sports-filter";
import NewBetSlip from "../../shared/betslip/new-betslip";
import { NewEventDetail } from "./new-eventdetail";
import MarketSelector from "./components/market-selector";
var clearFilters = function () {
    sportsbookFilter.filterKeyword = '';
    sportsbookFilter.filterDays = [];
    sportsbookFilter.filterMBS = [];
    sportsbookFilter.filterCompetition = [];
    sportsbookFilter.filterLiveStream = false;
    sportsbookFilter.filterFavorite = false;
};
var selectedLiveComp = [];
var page = 0;
var SportsBook = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var navigate = useNavigate();
    var params = useParams();
    var forceUpdate = useForceUpdate();
    var width = window.innerWidth;
    var sportSlug = params.sportSlug == 'tumu' ? 'futbol' : params.sportSlug;
    var sportsCompetitions;
    var eventDetail = null;
    var base = '/' + i18n.resolvedLanguage;
    var _b = useState(true), openLeftMenu = _b[0], setOpenLeftMenu = _b[1];
    var _c = useState(false), highLightedMarketModalIsOpened = _c[0], setHighLightedMarketModalIsOpened = _c[1];
    var _d = useState(null), selectedComp = _d[0], setSelectedComp = _d[1];
    var setHighLightedSelectedList = function (market, sportSlug) {
        var highlightedKey = "".concat(sportSlug).concat(params.eventType == 'canli' ? '-canli' : '');
        var indexOfMarket = myHighLightedMarketGroups[highlightedKey].indexOf(market);
        if (indexOfMarket !== -1) {
            myHighLightedMarketGroups[highlightedKey].splice(indexOfMarket, 1);
        }
        else {
            if (width > 1441) {
                if (myHighLightedMarketGroups[highlightedKey].length < 5) {
                    myHighLightedMarketGroups[highlightedKey].push(market);
                }
                else {
                    modalServiceSubject.next({
                        title: 'Uyarı',
                        content: 'En fazla 5 market seçebilirsiniz',
                        confirm: {
                            cancel: { label: t('Ok') }
                        },
                        timeout: 0,
                    });
                }
            }
            else if (width > 968) {
                if (myHighLightedMarketGroups[highlightedKey].length < 4) {
                    myHighLightedMarketGroups[highlightedKey].push(market);
                }
                else {
                    modalServiceSubject.next({
                        title: 'Uyarı',
                        content: 'En fazla 4 market seçebilirsiniz',
                        confirm: {
                            cancel: { label: t('Ok') }
                        },
                        timeout: 0,
                    });
                }
            }
            else {
                if (myHighLightedMarketGroups[highlightedKey].length < 2) {
                    myHighLightedMarketGroups[highlightedKey].push(market);
                }
                else {
                    modalServiceSubject.next({
                        title: 'Uyarı',
                        content: 'En fazla 2 market seçebilirsiniz',
                        confirm: {
                            cancel: { label: t('Ok') }
                        },
                        timeout: 0,
                    });
                }
            }
        }
        Storage.set("hlMarketCategoriesXWon", myHighLightedMarketGroups);
        forceUpdate();
    };
    useEffect(function () {
        if (width > 968) {
            var root = document.getElementById('root');
            root.classList.remove('is-home-page');
            root.classList.remove('betslip-Hidden');
            root.classList.add("page-full-size");
            root.classList.add("sportsbook");
            root.classList.add("betslip-Fixed");
            root.classList.add("compact-footer");
        }
        return function () {
        };
    }, []);
    useEffect(function () {
        var root = document.getElementById('root');
        if (params.eventType === 'canli') {
            if (root.classList.contains('prematch')) {
                root.classList.remove('prematch');
                root.classList.add("live");
            }
            else {
                root.classList.add("live");
            }
        }
        else {
            if (root.classList.contains('live')) {
                root.classList.remove('live');
                root.classList.add("prematch");
            }
            else {
                root.classList.add("prematch");
            }
        }
        clearFilters();
    }, [params.eventType]);
    useEffect(function () {
        var eventDetailSubject_subscription = eventDetailSubject.subscribe(function (res) {
            if (res && res === 'toggle') {
                eventDetailVisiblity.visible = false;
                closeEventDetail();
                forceUpdate();
            }
        });
        return function () {
            eventDetailSubject_subscription.unsubscribe();
        };
    }, []);
    var openEventDetail = function (event) {
        if (event) {
            eventDetailSubject.next(event);
        }
    };
    var closeEventDetail = function () {
        eventDetailSubject.next(false);
        eventDetailVisiblity.visible = false;
        document.body.style.overflow = 'unset';
        if (isMobileView) {
            forceUpdate();
        }
    };
    var goToUrl = function (sportSlug, eventType) {
        navigate(base + "/sports/" + sportSlug + '/' + params.eventType);
        if (isMobileView) {
            betSlipVisibleSubject.next(false);
        }
    };
    var originSportsbookList = _.orderBy(sportsbookList, ['eD', 'cGN', 'cN']).filter(function (el) {
        if (sportSlug === el.sS) {
            if ((params.eventType === 'tumu') ||
                (params.eventType === 'canli' && Number(el.iLE) === 1)) {
                return el;
            }
        }
        else if (sportSlug == null) {
            return el;
        }
    });
    var shownSportsBook = [];
    // fixme : performans iyileştirme lazım
    shownSportsBook = originSportsbookList.filter(function (el) {
        var filteredElement = el;
        if ((Number(filteredElement.iLE) === 0 || (Number(filteredElement.bP) === 0 && eventEndedStatuses.includes(filteredElement.liveScoreStatus))) &&
            marketMapping[String(filteredElement.eventId)].filter(function (m) { return Number(m.mS) !== 0; }).length === 0) {
            el.isRemoved = true;
            filteredElement = null;
        }
        else {
            el.isRemoved = false;
        }
        if (filteredElement && sportsbookFilter.filterCompetition.length > 0 && el.cId) {
            if (sportsbookFilter.filterCompetition.indexOf(el === null || el === void 0 ? void 0 : el.cId.toString()) !== -1) {
                filteredElement = el;
            }
            else {
                filteredElement = null;
            }
        }
        if (filteredElement && sportsbookFilter.filterDays.length > 0) {
            if (sportsbookFilter.filterDays.indexOf(el.eD.substring(0, 10)) !== -1) {
                filteredElement = el;
            }
            else {
                filteredElement = null;
            }
        }
        if (filteredElement && sportsbookFilter.filterTime >= 0) {
            try {
                var date = new Date(el.eD);
                var today = new Date();
                if (sportsbookFilter.filterTime == 0) {
                    if (date.getDate() == today.getDate()) {
                        filteredElement = el;
                    }
                    else {
                        filteredElement = null;
                    }
                }
                else {
                    var newDate = today.getTime() + sportsbookFilter.filterTime * 60000;
                    var eventDateTime = date.getTime();
                    if (eventDateTime <= newDate) {
                        filteredElement = el;
                    }
                    else {
                        filteredElement = null;
                    }
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        if (filteredElement && sportsbookFilter.filterLiveEvent) {
            if (Number(el.iLE) === 1) {
                filteredElement = el;
            }
            else {
                filteredElement = null;
            }
        }
        if (filteredElement && sportsbookFilter.filterFavorite) {
            if (el.isFavorite) {
                filteredElement = el;
            }
            else {
                filteredElement = null;
            }
        }
        if (filteredElement && sportsbookFilter.filterKeyword.length > 1) {
            if (el.eN.toLowerCase().indexOf(sportsbookFilter.filterKeyword.toLowerCase()) !== -1) {
                filteredElement = el;
            }
            else {
                filteredElement = null;
            }
        }
        if (filteredElement && params.eventType === 'canli') {
            if (Number(filteredElement.iLE) !== 1) {
                filteredElement = null;
            }
        }
        if (filteredElement) {
            if (params.eventType !== 'canli') {
                if (Number(filteredElement.bP) != 0) {
                    filteredElement = null;
                }
            }
        }
        if (filteredElement) {
            return filteredElement;
        }
    });
    useEffect(function () {
        var _a;
        if (params.eventId) {
            var reloadEvent = sportsbookList.find(function (el) { return Number(el.eventId) === Number(params.eventId); });
            if (reloadEvent) {
                openEventDetail(reloadEvent);
            }
            else {
                getEvent(Number(params.eventId)).then(function (event) {
                    event.isEnded = true;
                    societywonEventIdMapping[Number(event.eventId)] = event;
                    marketMapping[event.eventId] = event.markets;
                    // fillEventStatistics([Number(params.eventId)]).finally(() => {
                    openEventDetail(societywonEventIdMapping[Number(params.eventId)]);
                    // })
                });
            }
        }
        else {
            sportsbookFilter.filterCompetition = [];
            if (params.competitionId) {
                (_a = sportsbookFilter.filterCompetition).push.apply(_a, params.competitionId.split(','));
            }
            closeEventDetail();
            forceUpdate();
        }
    }, [params.eventId, params.competitionId]);
    var marketGroup = myHighLightedMarketGroups["".concat(sportSlug).concat(params.eventType == 'canli' ? '-canli' : '')];
    var marketGroup2 = myHighLightedMarketGroups2["".concat(sportSlug).concat(params.eventType == 'canli' ? '-canli' : '')];
    useEffect(function () {
        if (isMobileView) {
            if (!sportsbookFilter.selectedCompetitionGroup.competitionGroupName) {
                try {
                    var sportsCompetitions_1 = generateCompetitionGroupList(originSportsbookList, [sportSlug]);
                    sportsbookFilter.selectedCompetitionGroup = sportsCompetitions_1.filter(function (el) {
                        return el.competitionGroupName == shownSportsBook[0].competitionGroupName;
                    });
                }
                catch (e) {
                }
            }
            if (!mobileHighLightedMarket.selected) {
                mobileHighLightedMarket.selected = highLightedMarketCategories[params.sportSlug || 'futbol'][0];
            }
        }
    }, []);
    useEffect(function () {
        if (!isMobileView)
            return;
        var handleScroll = function () {
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var clientHeight = window.innerHeight;
            if (scrollTop > (clientHeight / 4)) {
                var newPage = Math.ceil(scrollTop / clientHeight);
                if (page < newPage) {
                    page = newPage;
                    forceUpdate();
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, [params.competitionId, params.eventType]);
    var vh = window.outerHeight;
    return (_jsxs(_Fragment, { children: [_jsx(SportsHeader, { onFilterChange: forceUpdate }, void 0), !isMobileView && _jsxs("div", __assign({ id: "sportsbook-container-id", className: "sportsbook-container multi-column-view  multi-column-view-expanded  ".concat(openLeftMenu ? 'openLeftMenu' : '') }, { children: [_jsx(SportBookSideMenu, { competitionId: params.competitionId, sportSlug: params.sportSlug, openLeftMenu: openLeftMenu, eventType: params.eventType, onFilterChange: forceUpdate }, void 0), _jsx("div", __assign({ className: "sportsbook-center-section" }, { children: _jsxs("div", __assign({ className: "sportsbook-center-section-scroll" }, { children: [(params.competitionId == null || params.eventId == null) &&
                                    _jsx("div", __assign({ className: "prematch-page-bc", id: "sportsbook-center-section-scroll", onScroll: function () {
                                            var listenerElement = document.getElementById('sportsbook-center-section-scroll');
                                            // @ts-ignore
                                            var sct = listenerElement.scrollTop;
                                            if (sct > (vh / 4)) {
                                                if (page < Math.ceil(sct / vh)) {
                                                    page = Math.ceil(sct / vh);
                                                    forceUpdate();
                                                }
                                            }
                                        } }, { children: _jsx("div", __assign({ className: "multi-column-resize-block", id: "multi-column-resize-block-scroll", onScroll: function () {
                                                var listenerElement = document.getElementById('multi-column-resize-block-scroll');
                                                // @ts-ignore
                                                var sct = listenerElement.scrollTop;
                                                if (sct > (vh / 4)) {
                                                    if (page < Math.ceil(sct / vh)) {
                                                        page = Math.ceil(sct / vh);
                                                        forceUpdate();
                                                    }
                                                }
                                            } }, { children: _jsxs("div", __assign({ className: "multi-column-container" }, { children: [_jsxs("ul", __assign({ className: "multi-column-header" }, { children: [_jsx("li", { children: _jsxs("div", __assign({ className: "multi-column-side-toggler" }, { children: [_jsx("img", { className: "cursor-pointer", alt: "side-menu-toggle", src: SideSquare, width: 25, height: 25, onClick: function () {
                                                                                setOpenLeftMenu(function (prevState) {
                                                                                    var leftMenu = document.getElementById('left-menu-container');
                                                                                    if (!prevState) {
                                                                                        leftMenu.style.display = "block";
                                                                                    }
                                                                                    else {
                                                                                        leftMenu.style.display = "none";
                                                                                    }
                                                                                    return !prevState;
                                                                                });
                                                                            } }, void 0), getFromLanguageFile(params.sportSlug) ? getFromLanguageFile(params.sportSlug) : params.sportSlug] }), void 0) }, "multi-column-key--1"), marketGroup && marketGroup.map(function (el, key) {
                                                                return (_jsxs(React.Fragment, { children: [key != 0 && _jsx("li", { className: "multi-column-base" }, void 0), _jsxs("li", __assign({ className: "".concat(el.outcomeCount > 2 ? '' +
                                                                                'multi-column-WINNER' : 'multi-column-HANDICAP', " multi-column-count-").concat(el.outcomeCount) }, { children: [_jsx("p", { children: t(el.name) }, void 0), _jsx("div", { children: (el.labels || []).map(function (marketLabel, marketLabelKey) {
                                                                                        return _jsx("b", { children: t(marketLabel) }, key + "-marketLabel-" + marketLabelKey);
                                                                                    }) }, void 0)] }), void 0)] }, "marketGroup-".concat(key)));
                                                            }), _jsx("li", {}, "multi-column-key--2")] }), void 0), _jsx(Eventlist, { page: page, openEventDetail: openEventDetail, sportsbookFilter: sportsbookFilter, params: params, shownSportsBook: shownSportsBook }, void 0)] }), void 0) }), void 0) }), void 0), _jsx(NewEventDetail, {}, void 0)] }), void 0) }), void 0), _jsx(NewBetSlip, {}, void 0)] }), void 0), isMobileView && _jsxs(_Fragment, { children: [(params.competitionId == null && params.eventId == null) &&
                        _jsx(MobileSportsFilter, { shownSportsBook: shownSportsBook, onFilterChange: forceUpdate }, void 0), ((params.competitionId != null || params.eventType == 'canli') && params.eventId == null) &&
                        _jsx(MarketSelector, { marketGroup: marketGroup2, onSelect: function (group) {
                                var key = "".concat(sportSlug).concat(params.eventType == 'canli' ? '-canli' : '');
                                mobileHighLightedMarket[key] = [group];
                                mobileHighLightedMarket.selected = group;
                                forceUpdate();
                            } }, void 0), !eventDetailVisiblity.visible &&
                        _jsx("div", __assign({ className: "prematch-page-bc" }, { children: params.competitionId == null ?
                                _jsx(_Fragment, { children: params.eventType == 'canli'
                                        ? _jsx("div", __assign({ className: "live-page-sections-bc ext-2" }, { children: sportsSummery.filter(function (el) { return el.sportSlug == sportSlug; }).map(function (item, key) {
                                                var sportsCompetitions = generateCompetitionGroupList(shownSportsBook, [item.sportSlug], true, ['cN', 'eD']);
                                                return _jsx(React.Fragment, { children: sportsCompetitions.map(function (itemComp, key) {
                                                        return _jsx(React.Fragment, { children: Object.entries(itemComp.competitions).map(function (comp, key) {
                                                                var _a;
                                                                var customGroupHeader = comp[0] + '' + itemComp.competitionGroupName + '_' + itemComp.sportId;
                                                                return (_jsxs("div", __assign({ className: "sp-sub-list-bc ".concat(selectedLiveComp.includes(customGroupHeader) ? "" : 'active selected') }, { children: [_jsxs("div", __assign({ onClick: function () {
                                                                                if (selectedLiveComp.includes(customGroupHeader)) {
                                                                                    selectedLiveComp = selectedLiveComp.toSpliced(selectedLiveComp.indexOf(customGroupHeader), 1);
                                                                                }
                                                                                else {
                                                                                    selectedLiveComp.push(customGroupHeader);
                                                                                }
                                                                                forceUpdate();
                                                                            }, className: "sp-s-l-head-bc", title: (_a = itemComp.competitionGroupName) === null || _a === void 0 ? void 0 : _a.replace('CCC', 'Ç').replace('SSS', 'Ş').replace('III', 'İ') }, { children: [_jsx("i", { className: "sp-s-l-h-flag-bc flag-bc ".concat(itemComp.competitionGroupName === "IIIskoçya" ? 'scotland' : itemComp.countryName.toLowerCase().replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '_')) }, void 0), _jsx("div", __assign({ className: "sp-s-l-h-title-content ellipsis" }, { children: _jsxs("p", __assign({ className: "sp-s-l-h-title-bc ellipsis" }, { children: [getFromLanguageFile(itemComp.competitionGroupNameId) ? getFromLanguageFile(itemComp.competitionGroupNameId) : itemComp.competitionGroupName, " ", getFromLanguageFile(comp[1][0].competitionNameId) ? getFromLanguageFile(comp[1][0].competitionNameId) : comp[1][0].competitionName] }), void 0) }), void 0), _jsx("span", __assign({ className: "sp-s-l-b-c-i-g-league-c-bc" }, { children: comp[1].length }), void 0), _jsx("i", { className: "sp-s-l-h-arrow-icon-bc bc-i-small-arrow-down" }, void 0)] }), void 0), _jsx("div", __assign({ className: "sp-s-l-b-content-bc" }, { children: comp[1].map(function (event, __key) {
                                                                                return _jsx("div", __assign({ className: "c-segment-holder-bc single-g-info-bc", id: "eventId_" + event.eventId }, { children: _jsx(MobileEvent, { event: event, eventType: params.eventType, context: openEventDetail }, void 0) }), key + "-event-side-" + __key);
                                                                            }) }), void 0)] }), "eventSporMenu-2-".concat(key)));
                                                            }) }, "sportsCompetitions-slug-" + key);
                                                    }) }, "sportsSummery-slug-" + key);
                                            }) }), void 0)
                                        : _jsx("div", __assign({ className: "pp-sport-list-holder-bc" }, { children: _jsx("div", __assign({ className: "left-menu-scroll" }, { children: sportsSummery.filter(function (el) { return el.sportSlug == sportSlug; }).map(function (item, key) {
                                                    var sportsCompetitions = generatePreCompetitionsGroupList(shownSportsBook, ['countryName'], false, ['coN']);
                                                    return _jsx(React.Fragment, { children: sportsCompetitions.map(function (itemComp, key) {
                                                            var _a;
                                                            return _jsxs("div", __assign({ className: "sp-sub-list-bc ".concat(selectedComp != null && selectedComp.countryName == itemComp.countryName && selectedComp.sportId == itemComp.sportId ? "active selected" : '') }, { children: [_jsxs("div", __assign({ onClick: function () {
                                                                            if (selectedComp == null) {
                                                                                setSelectedComp(itemComp);
                                                                            }
                                                                            else {
                                                                                if (selectedComp.competitionGroupName == itemComp.competitionGroupName && selectedComp.sportId == itemComp.sportId) {
                                                                                    setSelectedComp(null);
                                                                                }
                                                                                else {
                                                                                    setSelectedComp(itemComp);
                                                                                }
                                                                            }
                                                                            forceUpdate();
                                                                        }, className: "sp-s-l-head-bc", title: (_a = itemComp.competitionGroupName) === null || _a === void 0 ? void 0 : _a.replace('CCC', 'Ç').replace('SSS', 'Ş').replace('III', 'İ') }, { children: [_jsx("i", { className: "sp-s-l-h-flag-bc flag-bc ".concat(itemComp.competitionGroupName === "IIIskoçya" ? 'scotland' : itemComp.countryName.toLowerCase().replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '')) }, void 0), _jsx("div", __assign({ className: "sp-s-l-h-title-content ellipsis" }, { children: _jsx("p", __assign({ className: "sp-s-l-h-title-bc ellipsis" }, { children: getFromLanguageFile(itemComp.competitionGroupNameId) ? getFromLanguageFile(itemComp.competitionGroupNameId) : itemComp.countryName }), void 0) }), void 0), _jsx("span", __assign({ className: "sp-s-l-b-c-i-g-league-c-bc" }, { children: itemComp.count }), void 0), _jsx("i", { className: "sp-s-l-h-arrow-icon-bc bc-i-small-arrow-down" }, void 0)] }), void 0), _jsx("div", __assign({ className: "sp-s-l-b-content-bc" }, { children: Object.entries(itemComp.competitions).map(function (comp, _key) {
                                                                            var _a;
                                                                            return (_jsxs("div", __assign({ onClick: function () {
                                                                                    sportsbookFilter.selectedCompetitionGroup = itemComp;
                                                                                    navigate(base + "/sports/" + item.sportSlug + '/tumu/' + comp[1][0].cId);
                                                                                    window.scrollTo(0, 0);
                                                                                }, className: "sp-sub-list-bc " }, { children: [_jsxs("div", __assign({ className: "sp-s-l-head-bc", title: "" }, { children: [_jsx("div", __assign({ className: "sp-s-l-h-title-content ellipsis" }, { children: _jsx("p", __assign({ className: "sp-s-l-h-title-bc ellipsis" }, { children: (_a = comp[1][0].cN) === null || _a === void 0 ? void 0 : _a.replace('UEFA Şampiyonlar Ligi Elemeler', 'UEFA Şampiyonlar Ligi Elemeleri').replace('UEFA Avrupa Ligi, Elemeler', 'UEFA Avrupa Ligi Elemeleri') }), void 0) }), void 0), _jsx("span", __assign({ className: "sp-s-l-b-c-i-g-league-c-bc" }, { children: comp[1].length }), void 0)] }), void 0), _jsx("div", { className: "sp-s-l-b-content-bc" }, void 0)] }), "competitions-" + _key));
                                                                        }) }), void 0)] }), "eventSporMenu2".concat(key));
                                                        }) }, "sportsSummery-slug-" + key);
                                                }) }), void 0) }), void 0) }, void 0)
                                : _jsx(_Fragment, { children: params.eventId == null &&
                                        _jsx(Eventlist, { page: page, openEventDetail: openEventDetail, sportsbookFilter: sportsbookFilter, params: params, shownSportsBook: shownSportsBook }, void 0) }, void 0) }), void 0), _jsx(NewEventDetail
                    // eventType={params.eventType}
                    // sportSlug={params.sportSlug}
                    // closeEventDetail={closeEventDetail}
                    // openEventDetail={openEventDetail}
                    , {}, void 0)] }, void 0), _jsx(Modal, __assign({ isOpen: highLightedMarketModalIsOpened, onRequestClose: function () {
                    setHighLightedMarketModalIsOpened(false);
                    forceUpdate();
                }, ariaHideApp: false, style: {
                    content: {
                        background: "rgba(var(--header), 1)",
                        padding: "0",
                        left: "calc( 50% - 160px )",
                        top: "120px",
                        width: "400px",
                        height: "440px"
                    }
                } }, { children: _jsxs("div", __assign({ className: "popup-inner-bc" }, { children: [_jsx("i", { onClick: function () {
                                setHighLightedMarketModalIsOpened(false);
                            }, className: "e-p-close-icon-bc bc-i-close-remove" }, void 0), _jsx("div", __assign({ className: "entrance-popup-bc sign-in", style: { height: '440px' } }, { children: _jsx("div", __assign({ className: "e-p-content-holder-bc" }, { children: _jsxs("div", __assign({ className: "e-p-content-bc" }, { children: [_jsx("div", __assign({ className: "e-p-header-bc" }, { children: _jsx("div", __assign({ className: "sg-n-text-row-2-bc m-0" }, { children: t("selectMarkets") }), void 0) }), void 0), _jsx("div", __assign({ className: "e-p-body-bc" }, { children: _jsxs("form", __assign({ className: "entrance-form-bc login popup", "data-scroll-lock-scrollable": "" }, { children: [_jsxs("div", __assign({ className: "form-sign-bc" }, { children: [highLightedMarketCategories["".concat(params.sportSlug).concat(params.eventType == 'canli' ? '-canli' : '') || 'futbol'].map(function (marketGroup, key) {
                                                                if (marketGroup) {
                                                                    try {
                                                                        return (_jsx("div", __assign({ className: "entrance-f-item-bc entrance-f-item-checkbox-bc" }, { children: _jsx("div", __assign({ className: "checkbox-control-bc" }, { children: _jsxs("label", __assign({ className: "checkbox-control-content-bc" }, { children: [_jsx("input", { className: "checkbox-control-input-bc", type: "checkbox", checked: myHighLightedMarketGroups["".concat(params.sportSlug).concat(params.eventType == 'canli' ? '-canli' : '')].indexOf(marketGroup) !== -1, onChange: function () {
                                                                                                setHighLightedSelectedList(marketGroup, params.sportSlug);
                                                                                            } }, void 0), _jsx("i", { className: "checkbox-control-icon-bc bc-i-checked" }, void 0), _jsx("p", __assign({ className: "checkbox-control-text-bc" }, { children: t(marketGroup.name) }), void 0)] }), void 0) }), void 0) }), key));
                                                                    }
                                                                    catch (e) {
                                                                    }
                                                                }
                                                            }), _jsx("div", __assign({ className: "entrance-form-actions-holder-bc login-ext-1" }, { children: _jsx("div", __assign({ className: "entrance-form-action-item-bc right" }, { children: _jsx("button", __assign({ onClick: function () {
                                                                            setHighLightedMarketModalIsOpened(false);
                                                                        }, className: "btn a-color ", type: "button", title: "G\u0130R\u0130\u015E" }, { children: _jsx("span", { children: "t('Ok')" }, void 0) }), void 0) }), void 0) }), void 0)] }), void 0), _jsx("div", { className: "form-sign-in-slider-wrapper" }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0)] }), void 0) }), void 0)] }, void 0));
};
export default SportsBook;
